import { Injectable } from '@angular/core';
import { TwoFactorPurpose } from '@core/models';

@Injectable({ providedIn: 'root' })
export class TwoFactorAuthorizationStore {
  private readonly tokens = new Map<TwoFactorPurpose, string>();
  set(purpose: TwoFactorPurpose, token: string): void { this.tokens.set(purpose, token); }
  take(purpose: TwoFactorPurpose): string | undefined {
    const token = this.tokens.get(purpose); this.tokens.delete(purpose); return token;
  }
  clear(): void { this.tokens.clear(); }
}
